/**
 * Blacklist API клиент
 * Дата: 14.02.2026
 */
import { apiClient } from './client';

export interface BlacklistEntry {
  id: string;
  tenant_id: string;
  phone: string;
  phone_normalized: string;
  pcode?: string;
  reason: string;
  source: string;
  source_system: string;
  for_broadcasts: boolean;
  added_at: string;
  created_at: string;
  updated_at: string;
}

interface ListBlacklistParams {
  tenant_id?: string;
  limit?: number;
  offset?: number;
  search?: string;
}

interface ListBlacklistResponse {
  entries: BlacklistEntry[];
  total: number;
}

export async function listBlacklist(params: ListBlacklistParams): Promise<ListBlacklistResponse> {
  const { data } = await apiClient.get('/blacklist', { params });
  return data;
}

export async function createBlacklistEntry(entry: {
  tenant_id?: string;
  phone: string;
  pcode?: string;
  reason?: string;
  for_broadcasts?: boolean;
}): Promise<BlacklistEntry> {
  const { data } = await apiClient.post('/blacklist', entry);
  return data;
}

export async function removeBlacklistEntry(id: string): Promise<void> {
  await apiClient.delete(`/blacklist/${id}`);
}
